import { RichTextComponentType, RichTextListType, RichTextTextType } from '~/components/ux/atoms/RichText/types';

export interface PersonalizedPageElement {
  isOrdered?: boolean;
  marks?: string[];
  textContent: string;
  type: RichTextListType | RichTextTextType;
  uri?: string;
}

export interface PersonalizedPage {
  elements: PersonalizedPageElement[] | null;
  nodeType: RichTextComponentType;
}

export function usePersonalizedPage(content: string): PersonalizedPage[] | null {
  if (!content) {
    return null;
  }
  const document = JSON.parse(content);
  if (document.nodeType === 'document') {
    const { content } = document;
    return content.map((el: any) => {
      if (el?.nodeType && Object.values(RichTextTextType).includes(el.nodeType as RichTextTextType)) {
        return {
          elements: parseRichText(el),
          nodeType: RichTextComponentType.Text
        };
      } else if (el?.nodeType && Object.values(RichTextListType).includes(el.nodeType as RichTextListType)) {
        return {
          elements: parseRichTextLists(el),
          isOrdered: el.nodeType === RichTextListType.Ordered_list,
          nodeType: RichTextComponentType.List
        };
      }

      return null;
    });
  }
  return null;
}

function parseRichText(el: any) {
  return el.content.map((subEl: any) => {
    if (subEl.nodeType === RichTextTextType.hyperlink) {
      return {
        marks: subEl.content?.[0].marks?.map((mark: any) => mark?.type),
        textContent: subEl.content?.[0].value,
        type: RichTextTextType.hyperlink,
        uri: subEl.data.uri
      };
    }
    return {
      marks: subEl.marks?.map((mark: any) => mark?.type),
      textContent: subEl.value,
      type: el.nodeType
    };
  });
}

function parseRichTextLists(el: any) {
  return el.content.map((subEl: any) => {
    return {
      elements: subEl.content.map((el: any) => parseRichText(el)).flat(),
      nodeType: el.nodeType
    };
  });
}
